import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// Geographic locations dictionary
const CITIES_DATA = [
  {
    key: 'esbjerg',
    name: 'Esbjerg & omegn',
    synonyms: ['esbjerg', 'esberg', 'esbjærg', 'esbjergv', 'esbjerg-området', 'tjæreborg', 'bramming', 'guldager', 'fanø'],
    response: 'Ja, vi servicerer og leverer porte i hele Esbjerg og omegn! Med base i Vejen (Gestenvej 29) er vores servicebiler ofte i Esbjerg-området og kan hurtigt rykke ud til både lovpligtige serviceeftersyn, akutte reparationer og nye industri- eller garageporte.',
    bullets: [
      'Kort køretid og udrykning til hele Esbjerg, Bramming og opland',
      'Faste serviceaftaler for virksomheder, havneerhverv og boligforeninger',
      'Døgnvagt & akut hjælp ved påkørsel eller defekt port i Esbjerg',
      'Gratis opmåling og rådgivning på din adresse'
    ]
  },
  {
    key: 'kolding',
    name: 'Kolding & Trekantområdet',
    synonyms: ['kolding', 'koldin', 'lunderskov', 'vamdrup', 'almind', 'harte'],
    response: 'Ja, Kolding er en af vores absolutte primære hjemmebaner! Vores værksted i Vejen ligger kun få minutter væk, hvilket giver os markedets hurtigste responstid ved både serviceeftersyn, montage og akutte nedbrud.',
    bullets: [
      'Ultrakort udrykningstid til Kolding, Christiansfeld, Lunderskov og Vamdrup',
      'Professionel portservice på alle mærker (Hörmann, Nassau m.fl.)',
      'Levering og montering af ledhejseporte, hurtigløbere og brandporte',
      'Uforpligtende besigtigelse og tilbud direkte på din lokation'
    ]
  },
  {
    key: 'vejen',
    name: 'Vejen (Hovedsæde)',
    synonyms: ['vejen', 'vejen by', 'gesten', 'brørup', 'rødding', 'holsted', 'hovborg', 'lindknud', 'bække', 'glejbjerg', 'store andst', 'andst'],
    response: 'Pabst Teknik ApS har base og værksted lige her i Vejen på Gestenvej 29! Vi kender lokalområdet ud og ind og kan rykke ud inden for ganske kort tid til alle typer portopgaver og sikring.',
    bullets: [
      'Lokal forankring med værksted på Gestenvej 29, 6600 Vejen',
      'Øjeblikkelig assistance ved akutte driftsstop i hele Vejen Kommune',
      'Komplette løsninger inden for industriporte, garageporte & Ajax alarm',
      'Direkte personlig kontakt til indehaver Christian Pabst'
    ]
  },
  {
    key: 'vejle',
    name: 'Vejle & omegn',
    synonyms: ['vejle', 'vejlefjord', 'bredballe', 'jelling', 'børkop', 'grejs'],
    response: 'Ja, vi dækker hele Vejle og det omkringliggende opland! Vores montører kører dagligt i Trekantområdet for at udføre lovpligtige årseftersyn og levere nye skræddersyede portløsninger.',
    bullets: [
      'Daglig kørsel i Vejle og hele Trekantområdet',
      'Eksperter i energioptimerede hurtigløbere og isolerede ledhejseporte',
      'Sikkerhedsgodkendte brandporte og brandgardiner (EI30/EI60/EI120)',
      'Hurtigt og uforpligtende tilbud på eftersyn eller udskiftning'
    ]
  },
  {
    key: 'fredericia',
    name: 'Fredericia & Middelfart',
    synonyms: ['fredericia', 'fredericia havn', 'taulov', 'middelfart', 'strib', 'lillebælt'],
    response: 'Ja, vi udfører mange opgaver i Fredericia, Taulov og Middelfart! Særligt inden for logistik, industri, havnearealer og privatboliger servicerer vi alle typer port- og bomanlæg.',
    bullets: [
      'Erfaring med store logistikcentre og transportvirksomheder i Taulov/Fredericia',
      'Lovpligtige eftersyn efter Arbejdstilsynets gældende regler',
      'Automatiske skydeporte, bomme og områdesikring',
      'Dækker begge sider af Lillebælt med hurtig responstid'
    ]
  },
  {
    key: 'haderslev',
    name: 'Haderslev & Christiansfeld',
    synonyms: ['haderslev', 'vojens', 'sommersted', 'gram', 'christiansfeld', 'sønderjylland', 'sønderborg', 'aabenraa', 'tønder'],
    response: 'Ja, vi servicerer hele Haderslev, Christiansfeld og det øvrige Sønderjylland! Vi hjælper både landbrug, industrivirksomheder, autoværksteder og private med service, reparation og nye porte.',
    bullets: [
      'Kører fast i Haderslev, Christiansfeld, Vojens og Sønderjylland',
      'Specialister i store landbrugsporte, ledhejseporte og skydeporte',
      'Hurtig udrykning ved havari eller knækkede wirer/fjedre',
      'Konkurrencedygtige priser på faste serviceaftaler'
    ]
  },
  {
    key: 'ribe',
    name: 'Ribe & Sydvestjylland',
    synonyms: ['ribe', 'gredstedbro', 'spandet', 'hviding', 'roager', 'skærbæk'],
    response: 'Ja, vi dækker naturligvis Ribe og det sydvestjyske område! Uanset om det gælder service på eksisterende porte eller montering af en ny automatisk ledhejseport, står vi klar.',
    bullets: [
      'Tæt på Vejen med nem og hurtig adgang til hele Ribe-området',
      'Service på alle portmærker uanset alder og fabrikat',
      'Mulighed for gratis opmåling og rådgivning hos dig',
      'Installation af Ajax trådløse alarmsystemer til bolig og erhverv'
    ]
  },
  {
    key: 'varde',
    name: 'Varde & Vestjylland',
    synonyms: ['varde', 'ølgod', 'nr. nebel', 'nørre nebel', 'blaavand', 'blåvand', 'oksbøl', 'vestjylland', 'skjern', 'tarm'],
    response: 'Ja, vi kører i hele Varde kommune og langs den vestjyske kyst! Vi servicerer både erhvervsbygninger, haller, sommerhuse og private boliger.',
    bullets: [
      'Dækker Varde, Oksbøl, Blåvand, Ølgod og omegn',
      'Robuste portløsninger modstandsdygtige over for vestkystens vejrforhold',
      'Udrykning ved akutte driftsproblemer og reparationer',
      'Attraktive priser på serviceaftaler og eftersyn'
    ]
  },
  {
    key: 'fyn',
    name: 'Fyn & Odense',
    synonyms: ['fyn', 'odense', 'svendborg', 'nyborg', 'bogense', 'assens', 'ringe'],
    response: 'Ja, Pabst Teknik udfører også opgaver og serviceaftaler på Fyn! Vi krydser jævnligt Lillebæltsbroen til både større projekter og faste erhvervsaftaler.',
    bullets: [
      'Serviceaftaler på ledhejseporte, hurtigløbere og brandporte',
      'Installation af moderne alarmsystemer og adgangskontrol',
      'Professionelt eftersyn iht. Arbejdstilsynets bekendtgørelser',
      'Kontakt os for at høre om kørselsplan og tidspunkt for dit projekt'
    ]
  }
];

// Comprehensive knowledge base for Pabst Teknik ApS
const KNOWLEDGE_TOPICS = [
  {
    id: 'portservice',
    title: 'Portservice & Lovpligtigt Eftersyn',
    shortLabel: '🛠️ Portservice & Eftersyn',
    badge: 'Kerneydelse',
    keywords: ['portservice', 'eftersyn', 'serviceaftale', 'lovpligtigt', 'arbejdstilsynet', 'årseftersyn', 'vedligehold', 'service', 'eftersynsaftale', 'tjek', 'inspektion'],
    summary: 'Vi udfører professionelt og lovpligtigt årligt eftersyn samt forebyggende vedligeholdelse på alle typer industriporte, garageporte og bomme.',
    bullets: [
      'Overholder alle Arbejdstilsynets krav og EN-standarder',
      'Komplet servicerapport og godkendelsesmærkat medfølger',
      'Vi servicerer ALLE fabrikater (Hörmann, Nassau, Crawford, Lindab m.fl.)',
      'Forlænger portens levetid og minimerer risiko for dyre driftstop'
    ],
    primaryAction: { label: 'Læs om Portservice', url: '/ydelser' },
    secondaryAction: { label: 'Book eftersyn / Få tilbud', url: '/kontakt?emne=portservice' }
  },
  {
    id: 'akut',
    title: 'Akut Reparation & Døgnvagt',
    shortLabel: '🚨 Akut reparation & havari',
    badge: 'Hurtig udrykning',
    keywords: ['akut', 'stykker', 'stykke', 'ødelagt', 'skade', 'fastklemt', 'knækket', 'wire', 'reparation', 'haster', 'nødsituation', 'døgnvagt', 'påkørsel', 'nødstop', 'åbne', 'lukke'],
    summary: 'Er porten gået i stå, påkørt eller knækket en wire? Vi rykker hurtigt ud og hjælper dig med akut portreparation.',
    bullets: [
      'Hurtig responstid i Vejen, Kolding, Esbjerg og hele Trekantområdet',
      'Veludstyrede servicebiler med gængse reservedele klar',
      'Erfarne montører der hurtigt sikrer eller reparerer porten',
      'Ring direkte til vagten for øjeblikkelig assistance'
    ],
    primaryAction: { label: 'Ring straks: 21 68 44 22', href: 'tel:+4521684422' },
    secondaryAction: { label: 'Send akut besked', url: '/kontakt?emne=akut-reparation' }
  },
  {
    id: 'ledhejseporte',
    title: 'Ledhejseporte & Industriporte',
    shortLabel: '🚪 Ledhejse- & Industriporte',
    badge: 'Populært valg',
    keywords: ['ledhejseport', 'ledhejseporte', 'industriport', 'industriporte', 'garageport', 'garageporte', 'ledhejs', 'sektionsport', 'isolering', 'portautomatik'],
    summary: 'Robuste og højtisolerede ledhejseporte skræddersyet til lagerhaller, værksteder, landbrug og private garager.',
    bullets: [
      'Fremragende isoleringsevne (sandwichpaneler med brudt kuldebro)',
      'Mulighed for ruder, fuldpanorama-sektioner og integreret gangdør',
      'Kvalitetsautomatik med fjernbetjening, kodelås og app-styring',
      'Produceret i målfast kvalitet med lang holdbarhed'
    ],
    primaryAction: { label: 'Se portløsninger', url: '/ydelser' },
    secondaryAction: { label: 'Se billeder i galleri', url: '/galleri' }
  },
  {
    id: 'lindab',
    title: 'Lindab Portservice & Løsninger',
    shortLabel: '🚪 Lindab Portsystemer',
    badge: 'Salgspartner for Portservice',
    keywords: ['lindab', 'lindab port', 'lindab porte', 'lindab garageport', 'lindab industriport', 'lindab reservedele', 'forhandler af lindab', 'lindab portservice'],
    summary: 'Lindab fungerer som en stærk salgspartner for vores professionelle portservice. Vi leverer, monterer og servicerer originale Lindab portsystemer og tilbehør.',
    bullets: [
      'Originale Lindab portløsninger til både private garager og erhvervsbyggeri',
      'Højeste skandinaviske kvalitet, robust overfladebehandling og lang levetid',
      'Professionel opmåling, autoriseret montage og efterfølgende serviceeftersyn',
      'Stort udvalg af automatiske motorer, kodelåse og originale reservedele'
    ],
    primaryAction: { label: 'Se portløsninger', url: '/ydelser' },
    secondaryAction: { label: 'Få tilbud på Lindab port', url: '/kontakt?emne=lindab-port' }
  },
  {
    id: 'hurtigloebere',
    title: 'Hurtigløberporte (Speedporte)',
    shortLabel: '⚡ Hurtigløberporte',
    badge: 'Energioptimeret',
    keywords: ['hurtigløber', 'hurtigløbere', 'hurtigløberport', 'hurtigløberporte', 'speedport', 'speedporte', 'dugport', 'kølerum', 'vaskehaller', 'produktion'],
    summary: 'Ekstremt hurtige dug- og lamelporte designet til intens trafik og steder, hvor der stilles høje krav til temperaturkontrol og logistik.',
    bullets: [
      'Åbne- og lukkehastighed op til 2,5 m/s minimerer træk og varmetab',
      'Selvreparerende duge ved let påkørsel (reducerer reparationsomkostninger)',
      'Ideel til vaskehaller, fødevarevirksomheder, lagre og kølerum',
      'Støjsvag og driftsikker drift under selv krævende forhold'
    ],
    primaryAction: { label: 'Læs om hurtigløbere', url: '/ydelser' },
    secondaryAction: { label: 'Indhent uforpligtende tilbud', url: '/kontakt?emne=hurtigloebere' }
  },
  {
    id: 'brandporte',
    title: 'Brandporte & Brandgardiner',
    shortLabel: '🔥 Brandporte & Gardiner',
    badge: 'Sikkerhedsgodkendt',
    keywords: ['brandport', 'brandporte', 'brandgardin', 'brandgardiner', 'brand', 'brandsikring', 'ei30', 'ei60', 'ei120', 'abdl', 'branddør', 'brandsektionering'],
    summary: 'Godkendte og certificerede brandlukninger, der forhindrer spredning af røg og flammer og beskytter værdier og menneskeliv.',
    bullets: [
      'Testet og godkendt iht. europæiske brandkrav (EI30, EI60, EI120)',
      'Integreres direkte med bygningens ABA- og ABDL-varslingsanlæg',
      'Pladsbesparende brandgardiner til usynlig integrering i lofter',
      'Lovpligtig årlig inspektion og afprøvning af udløserfunktioner'
    ],
    primaryAction: { label: 'Udforsk brandløsninger', url: '/ydelser' },
    secondaryAction: { label: 'Få rådgivning om brandkrav', url: '/kontakt?emne=brandporte' }
  },
  {
    id: 'skydeporte',
    title: 'Skydeporte & Fritbærende Områdesikring',
    shortLabel: '🚧 Skydeporte & Hegn',
    badge: 'Perimetersikring',
    keywords: ['skydeport', 'skydeporte', 'fritbærende', 'hegn', 'indhegning', 'områdesikring', 'adgangskontrol', 'bomanlæg', 'bomme', 'portautomatik'],
    summary: 'Robuste skydeporte og bomanlæg til sikker afspærring af virksomhedens grund, byggepladser eller logistikarealer.',
    bullets: [
      'Fritbærende konstruktion uden bundskinne – ingen problemer med sne/grus',
      'Integreret adgangskontrol (GSM-modul, nummerpladegenkendelse, brik/kort)',
      'Galvaniseret eller pulverlakeret i enhver RAL-farve',
      'Sikrer mod uautoriseret adgang døgnet rundt'
    ],
    primaryAction: { label: 'Se skydeporteløsninger', url: '/ydelser' },
    secondaryAction: { label: 'Få tilbud på områdesikring', url: '/kontakt?emne=skydeporte' }
  },
  {
    id: 'ajax-alarm',
    title: 'Ajax Alarmer & Videoovervågning',
    shortLabel: '🛡️ Ajax Alarmsystemer',
    badge: 'Intelligent Sikring',
    keywords: ['ajax', 'alarm', 'alarmsystem', 'alarmsystemer', 'alarmer', 'tyverisikring', 'videoovervågning', 'kamera', 'overvågning', 'sikring', 'sensor', 'røgdetektor', 'vandskade'],
    summary: 'Pabst Teknik er autoriseret installatør af det trådløse og prisbelønnede Ajax Systems alarmsystem til både private og erhverv.',
    bullets: [
      '100% trådløs installation med elegant design og lang batteritid',
      'Fotoverifikation (MotionCam) sender billeder direkte til din mobil på sekunder',
      'Brugervenlig app til iOS & Android med push-beskeder i realtid',
      'Mulighed for godkendt kontrolcentralsopkobling og vægterudkald'
    ],
    primaryAction: { label: 'Læs om Ajax Sikring', url: '/ydelser' },
    secondaryAction: { label: 'Få et sikringstjek & tilbud', url: '/kontakt?emne=ajax-alarm' }
  },
  {
    id: 'priser-tilbud',
    title: 'Priser & Uforpligtende Tilbud',
    shortLabel: '💰 Få et uforpligtende tilbud',
    badge: 'Gratis opmåling',
    keywords: ['pris', 'priser', 'koster', 'hvad koster', 'tilbud', 'uforpligtende', 'beregn', 'overslag', 'budget', 'betaling', 'rabat', 'timepris'],
    summary: 'Vi giver altid gerne et uforpligtende prisoverslag eller kommer ud og måler op til dit næste projekt.',
    bullets: [
      'Gennemskuelige priser og ingen ubehagelige overraskelser',
      'Faste konkurrencedygtige priser på serviceaftaler og eftersyn',
      'Skræddersyede løsninger der matcher dine konkrete mål og behov',
      'Hurtigt tilbud fremsendt inden for 24 timer på hverdage'
    ],
    primaryAction: { label: 'Udfyld tilbudsformular', url: '/kontakt' },
    secondaryAction: { label: 'Ring til Christian på 21 68 44 22', href: 'tel:+4521684422' }
  },
  {
    id: 'omraade-geografi',
    title: 'Område & Dækning (Hvor kører vi?)',
    shortLabel: '📍 Hvor kører Pabst Teknik?',
    badge: 'Hele regionen',
    keywords: ['hvor', 'kører', 'område', 'vejen', 'kolding', 'christiansfeld', 'esbjerg', 'trekantområdet', 'jylland', 'fyn', 'danmark', 'adresse', 'vestjylland', 'sønderjylland', 'haderslev', 'fredericia'],
    summary: 'Pabst Teknik ApS har base i Vejen og servicerer dagligt kunder i hele Sydjylland, Trekantområdet, Fyn og det øvrige Jylland.',
    bullets: [
      'Hovedsæde og værksted beliggende på Gestenvej 29, 6600 Vejen',
      'Korte responstider i Vejen, Kolding, Christiansfeld, Esbjerg, Fredericia og Vejle',
      'Kørende montører i hele Jylland og på Fyn efter aftale',
      'Både for private, landbrug, boligforeninger og industrikunder'
    ],
    primaryAction: { label: 'Læs mere om Pabst Teknik', url: '/om-os' },
    secondaryAction: { label: 'Kontakt vores kontor', url: '/kontakt' }
  },
  {
    id: 'samarbejdspartner',
    title: 'Samarbejde med Dansk Portservice Claus Hygum ApS',
    shortLabel: '🤝 Samarbejde & Landsdækkende',
    badge: '1 Fælles Koncept',
    keywords: ['samarbejde', 'samarbejdspartner', 'dansk portservice', 'claus hygum', 'claus hygum aps', 'partner', 'partnerfirma', 'koncept', 'landsdækkende', 'sjælland', 'københavn', 'hele landet', 'rækkevidde', 'dækning danmark'],
    summary: 'Vi er to separate virksomheder – Pabst Teknik ApS og Dansk Portservice Claus Hygum ApS – der arbejder sammen om ét fælles koncept. Det giver os en stor rækkevidde på tværs af hele landet.',
    bullets: [
      'Samarbejdspartner: Dansk Portservice Claus Hygum ApS',
      'Stor landsdækkende rækkevidde med lokal forankring',
      'Tæt intern kommunikation sikrer en god og fyldestgørende oplevelse fra start til slut',
      'Fælles høje standarder for faglighed, opmåling og montage'
    ],
    primaryAction: { label: 'Besøg Dansk Portservice Claus Hygum ApS', href: 'https://0298fb46-c259-4129-b655-7c68adb8d499.sites.auxodev.dk/' },
    secondaryAction: { label: 'Læs mere om os', url: '/om-os' }
  },
  {
    id: 'kontakt-info',
    title: 'Kontakt & Åbningstider',
    shortLabel: '📞 Kontakt & Åbningstider',
    badge: 'Direkte kontakt',
    keywords: ['kontakt', 'åbningstid', 'åbningstider', 'telefon', 'nummer', 'mail', 'email', 'adresse', 'cvr', 'find os', 'kontaktperson', 'christian pabst'],
    summary: 'Du er altid velkommen til at kontakte os for rådgivning, spørgsmål eller servicebestilling.',
    bullets: [
      'Telefon: 21 68 44 22 (mandag-fredag + vagt ved akutte stop)',
      'E-mail: kontakt@pabstteknik.dk',
      'Adresse: Gestenvej 29, 6600 Vejen | CVR: 42228842',
      'Direkte indehaver: Christian Pabst'
    ],
    primaryAction: { label: 'Gå til kontaktsiden', url: '/kontakt' },
    secondaryAction: { label: 'Ring: 21 68 44 22', href: 'tel:+4521684422' }
  }
];

export default function ChatGuide() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [hasUnread, setHasUnread] = useState(true);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
  const navigate = useNavigate();

  // Initialize welcome message
  useEffect(() => {
    setMessages([
      {
        id: 'welcome-1',
        sender: 'bot',
        type: 'welcome',
        text: 'Hej! Velkommen til Pabst Teknik 👋',
        subtext: 'Jeg er din digitale rådgiver. Hvad kan vi hjælpe dig med i dag? Klik på et emne herunder eller skriv dit spørgsmål:',
        timestamp: new Date()
      }
    ]);
  }, []);

  // Auto-scroll to bottom of conversation
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    if (isOpen) {
      scrollToBottom();
      setHasUnread(false);
      setTimeout(() => {
        inputRef.current?.focus();
      }, 200);
    }
  }, [isOpen, messages, isTyping]);

  // Handle ESC key to close
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        setIsOpen(false);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  // Natural Language & Intent Matcher
  const analyzeQueryIntent = (query) => {
    const raw = query.toLowerCase().trim();
    if (!raw) return null;

    // Normalizing common spelling/typos and variants
    const normalized = raw
      .replace(/[\?\,\.\!\:\;]/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/\bbord\b/g, 'bor')
      .replace(/\bkøre\b/g, 'kører')
      .replace(/\bkontakts\b/g, 'kontaktes')
      .replace(/\bkontakteds\b/g, 'kontaktes')
      .replace(/\bringes\b/g, 'ringe')
      .replace(/\bnummeret\b/g, 'nummer');

    // 1. Check Contact / Callback intent
    const contactPhrases = [
      'vil gerne kontaktes', 'kontakt mig', 'ring til mig', 'ring mig op',
      'kan i ringe', 'kan i kontakte mig', 'vil kontaktes', 'kontakt os',
      'kan du kontakte mig', 'send mig en mail', 'kontaktformular', 'nummer',
      'telefonnummer', 'telefon', 'ringe op', 'blive ringet op', 'kontaktes',
      'vil gerne ringes op', 'ring til os', 'hvem kan jeg ringe til', 'snakke med jer',
      'snakke med en rådgiver', 'have et opkald', 'kontakt', 'ring mig'
    ];

    const isContactIntent = contactPhrases.some(phrase => normalized.includes(phrase));
    if (isContactIntent) {
      return {
        type: 'contact',
        data: {
          title: 'Vi kontakter dig meget gerne!',
          badge: 'Hurtig kontakt',
          summary: 'Du kan enten ringe direkte til os med det samme, eller udfylde vores kontaktformular – så vender Christian eller en montør tilbage til dig hurtigst muligt.',
          bullets: [
            'Direkte telefon: 21 68 44 22 (mandag-fredag + døgnvagt ved stop)',
            'Skriv via kontaktformularen – svar inden for 24 timer på hverdage',
            'Uforpligtende rådgivning om eftersyn, reparation og nye porte'
          ]
        }
      };
    }

    // 2. Check City / Geographic intent
    for (const city of CITIES_DATA) {
      const matchCity = city.synonyms.some(syn => {
        // Direct inclusion or "bor i [city]", "i [city]", "[city]"
        return normalized.includes(syn) || 
               normalized.includes(`bor i ${syn}`) ||
               normalized.includes(`kører i ${syn}`) ||
               normalized.includes(`til ${syn}`);
      });

      if (matchCity) {
        return {
          type: 'location',
          city: city
        };
      }
    }

    // 3. Check direct topic keywords / score
    const directTopic = KNOWLEDGE_TOPICS.find(t => t.id === raw);
    if (directTopic) {
      return { type: 'topic', topic: directTopic };
    }

    let bestMatch = null;
    let highestScore = 0;

    KNOWLEDGE_TOPICS.forEach(topic => {
      let score = 0;
      const topicTitle = topic.title.toLowerCase();
      const topicSummary = topic.summary.toLowerCase();

      topic.keywords.forEach(kw => {
        if (normalized.includes(kw)) {
          score += 5;
        }
        if (kw.includes(normalized) && normalized.length > 3) {
          score += 3;
        }
      });

      if (topicTitle.includes(normalized)) {
        score += 8;
      }
      if (topicSummary.includes(normalized)) {
        score += 2;
      }

      if (score > highestScore) {
        highestScore = score;
        bestMatch = topic;
      }
    });

    if (highestScore >= 3 && bestMatch) {
      return { type: 'topic', topic: bestMatch };
    }

    // Fallback
    return { type: 'fallback', query: query };
  };

  // Bot response handlers
  const handleQueryResponse = (intentResult, originalQuery) => {
    setIsTyping(true);

    setTimeout(() => {
      setIsTyping(false);

      if (intentResult.type === 'contact') {
        setMessages(prev => [
          ...prev,
          {
            id: `bot-${Date.now()}`,
            sender: 'bot',
            type: 'contact_intent',
            data: intentResult.data,
            timestamp: new Date()
          }
        ]);
      } else if (intentResult.type === 'location') {
        setMessages(prev => [
          ...prev,
          {
            id: `bot-${Date.now()}`,
            sender: 'bot',
            type: 'location_intent',
            city: intentResult.city,
            timestamp: new Date()
          }
        ]);
      } else if (intentResult.type === 'topic') {
        setMessages(prev => [
          ...prev,
          {
            id: `bot-${Date.now()}`,
            sender: 'bot',
            type: 'topic_answer',
            topic: intentResult.topic,
            timestamp: new Date()
          }
        ]);
      } else {
        setMessages(prev => [
          ...prev,
          {
            id: `bot-${Date.now()}`,
            sender: 'bot',
            type: 'fallback',
            query: originalQuery,
            text: `Tak for din henvendelse! For at give dig det mest præcise svar vil vi anbefale at kontakte os direkte eller vælge en af kategorierne herunder:`,
            timestamp: new Date()
          }
        ]);
      }
    }, 400);
  };

  // Handle user submit via text input
  const handleSendMessage = (e) => {
    e.preventDefault();
    const query = inputValue.trim();
    if (!query) return;

    const userMsg = {
      id: `user-${Date.now()}`,
      sender: 'user',
      text: query,
      timestamp: new Date()
    };

    setMessages(prev => [...prev, userMsg]);
    setInputValue('');

    const intentResult = analyzeQueryIntent(query);
    handleQueryResponse(intentResult, query);
  };

  // Handle clicking quick category button
  const handleSelectQuickTopic = (topic) => {
    const userMsg = {
      id: `user-${Date.now()}`,
      sender: 'user',
      text: topic.shortLabel || topic.title,
      timestamp: new Date()
    };
    setMessages(prev => [...prev, userMsg]);
    handleQueryResponse({ type: 'topic', topic: topic }, topic.title);
  };

  // Reset conversation
  const handleResetChat = () => {
    setMessages([
      {
        id: `welcome-${Date.now()}`,
        sender: 'bot',
        type: 'welcome',
        text: 'Samtalen er nulstillet 👋',
        subtext: 'Hvad kan vi hjælpe dig med? Vælg et emne eller skriv i feltet herunder:',
        timestamp: new Date()
      }
    ]);
  };

  return (
    <>
      {/* Floating Trigger Button */}
      <div className="fixed bottom-5 right-5 z-50 flex items-center gap-3 select-none">
        
        {/* Pulse Hint Tooltip (shown when chat is closed) */}
        {!isOpen && (
          <button
            onClick={() => setIsOpen(true)}
            className="hidden sm:flex items-center gap-2.5 bg-brand-dark text-white px-4 py-2.5 rounded-full shadow-xl border border-slate-700/60 hover:bg-slate-800 transition-all duration-300 transform hover:-translate-y-0.5 group text-left"
          >
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500"></span>
            </span>
            <div className="text-xs">
              <div className="font-semibold text-slate-100 group-hover:text-brand-accent transition-colors">
                Har du spørgsmål til porte?
              </div>
              <div className="text-[11px] text-slate-400">
                Få hurtig rådgivning & tilbud
              </div>
            </div>
          </button>
        )}

        {/* Main Floating Bubble Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          aria-label={isOpen ? 'Luk rådgiver' : 'Åbn rådgivningschat'}
          className={`relative flex items-center justify-center w-14 h-14 rounded-full shadow-2xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-brand-accent/30 ${
            isOpen 
              ? 'bg-slate-800 text-white rotate-90' 
              : 'bg-gradient-to-tr from-brand-accent to-[#ff474d] text-white hover:shadow-brand-accent/40'
          }`}
        >
          {isOpen ? (
            <svg className="w-6 h-6 transform -rotate-90 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <>
              <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
              </svg>
              
              {/* Notification red dot if unread */}
              {hasUnread && (
                <span className="absolute top-0 right-0 flex h-4 w-4">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-4 w-4 bg-amber-500 border-2 border-white text-[9px] font-bold text-slate-900 items-center justify-center">
                    !
                  </span>
                </span>
              )}
            </>
          )}
        </button>
      </div>

      {/* Chat Window Dialog Overlay */}
      {isOpen && (
        <div 
          className="fixed bottom-22 right-4 sm:right-6 z-50 w-[calc(100vw-2rem)] sm:w-[440px] max-h-[85vh] h-[660px] flex flex-col bg-white rounded-2xl shadow-2xl border border-slate-200/90 overflow-hidden animate-in fade-in slide-in-from-bottom-5 duration-200"
          role="dialog"
          aria-modal="true"
          aria-label="Pabst Teknik Assistent-bot"
        >
          {/* Window Header */}
          <div className="bg-gradient-to-r from-brand-dark via-slate-900 to-slate-800 text-white px-4 py-3.5 flex items-center justify-between shadow-md select-none">
            <div className="flex items-center gap-3">
              {/* Robot Icon */}
              <div className="relative">
                <div className="w-10 h-10 rounded-full bg-slate-800 border-2 border-slate-600 flex items-center justify-center text-brand-accent shadow-inner">
                  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="10" rx="2" />
                    <circle cx="12" cy="5" r="2" />
                    <path d="M12 7v4" />
                    <line x1="8" y1="16" x2="8" y2="16.01" />
                    <line x1="16" y1="16" x2="16" y2="16.01" />
                  </svg>
                </div>
                <span className="absolute bottom-0 right-0 w-3 h-3 bg-emerald-500 border-2 border-slate-900 rounded-full" />
              </div>

              <div>
                <div className="flex items-center gap-1.5 font-bold text-[15px] text-white">
                  <span>Pabst Teknik Bot</span>
                </div>
                <div className="text-[12px] text-slate-300 flex items-center gap-1.5 font-medium">
                  <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
                  <span>Automatisk guide • Svarer 24/7</span>
                </div>
              </div>
            </div>

            {/* Header Controls */}
            <div className="flex items-center gap-1">
              <button
                onClick={handleResetChat}
                title="Nulstil samtale"
                className="p-1.5 text-slate-300 hover:text-white hover:bg-slate-700/60 rounded-lg transition-colors"
                aria-label="Nulstil samtale"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
              </button>
              <button
                onClick={() => setIsOpen(false)}
                title="Luk rådgiver"
                className="p-1.5 text-slate-300 hover:text-white hover:bg-slate-700/60 rounded-lg transition-colors"
                aria-label="Luk vindue"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>

          {/* Quick Contact Bar at top of chat */}
          <div className="bg-slate-100 border-b border-slate-200 px-4 py-2 flex items-center justify-between text-xs sm:text-[13px] text-slate-800">
            <span className="font-semibold text-slate-700">Brug for øjeblikkelig hjælp?</span>
            <div className="flex items-center gap-2">
              <a
                href="tel:+4521684422"
                className="inline-flex items-center gap-1.5 font-bold text-slate-900 hover:text-brand-accent transition-colors bg-white px-3 py-1 rounded-md border border-slate-300 shadow-2xs text-xs sm:text-sm"
              >
                <svg className="w-3.5 h-3.5 text-brand-accent" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.02-.24 11.72 11.72 0 003.68.59 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.72 11.72 0 00.59 3.68 1 1 0 01-.24 1.02l-2.23 2.09z" />
                </svg>
                <span>21 68 44 22</span>
              </a>
            </div>
          </div>

          {/* Chat Messages List */}
          <div className="flex-1 overflow-y-auto p-4 sm:p-5 space-y-4 bg-slate-50/60">
            {messages.map((msg) => (
              <div
                key={msg.id}
                className={`flex flex-col ${msg.sender === 'user' ? 'items-end' : 'items-start'}`}
              >
                {/* User Message Bubble */}
                {msg.sender === 'user' && (
                  <div className="max-w-[85%] bg-brand-dark text-white px-4 py-2.5 rounded-2xl rounded-tr-xs shadow-sm text-sm sm:text-[14.5px] font-medium leading-relaxed">
                    <p className="whitespace-pre-wrap">{msg.text}</p>
                  </div>
                )}

                {/* Bot Welcome Bubble */}
                {msg.sender === 'bot' && msg.type === 'welcome' && (
                  <div className="space-y-3.5 max-w-[94%]">
                    <div className="bg-white border border-slate-200 text-slate-900 p-4 rounded-2xl rounded-tl-xs shadow-sm space-y-1.5">
                      <p className="font-bold text-slate-950 text-sm sm:text-[15px]">{msg.text}</p>
                      <p className="text-slate-800 text-xs sm:text-[13.5px] leading-relaxed">{msg.subtext}</p>
                    </div>

                    {/* Quick Topics Grid */}
                    <div className="pt-1">
                      <div className="text-[11.5px] font-bold text-slate-700 uppercase tracking-wider mb-2.5">
                        Populære emner:
                      </div>
                      <div className="flex flex-wrap gap-2">
                        {KNOWLEDGE_TOPICS.slice(0, 6).map((topic) => (
                          <button
                            key={topic.id}
                            onClick={() => handleSelectQuickTopic(topic)}
                            className="bg-white hover:bg-red-50 hover:border-brand-accent text-slate-800 hover:text-brand-accent border border-slate-300 px-3 py-2 rounded-lg text-xs sm:text-[13px] font-semibold transition-all shadow-2xs text-left"
                          >
                            {topic.shortLabel}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* Bot Contact Intent Answer */}
                {msg.sender === 'bot' && msg.type === 'contact_intent' && msg.data && (
                  <div className="max-w-[96%] bg-white border border-slate-200 rounded-2xl rounded-tl-xs shadow-sm p-4 sm:p-4.5 text-slate-900 space-y-3.5 animate-in fade-in duration-200">
                    <div className="flex items-center justify-between gap-2 border-b border-slate-100 pb-2.5">
                      <span className="font-bold text-brand-dark text-sm sm:text-base flex items-center gap-1.5">
                        <span>📞</span>
                        <span>{msg.data.title}</span>
                      </span>
                      <span className="text-xs bg-emerald-100 text-emerald-900 font-bold px-2.5 py-0.5 rounded-full whitespace-nowrap">
                        {msg.data.badge}
                      </span>
                    </div>

                    <p className="text-xs sm:text-[14px] text-slate-800 leading-relaxed font-normal">
                      {msg.data.summary}
                    </p>

                    {msg.data.bullets && (
                      <ul className="space-y-2 bg-slate-50 p-3 rounded-xl border border-slate-200/80">
                        {msg.data.bullets.map((bullet, idx) => (
                          <li key={idx} className="flex items-start gap-2 text-xs sm:text-[13.5px] text-slate-800 leading-normal">
                            <span className="text-emerald-600 font-bold mt-0.5 text-sm">✓</span>
                            <span>{bullet}</span>
                          </li>
                        ))}
                      </ul>
                    )}

                    <div className="flex flex-col gap-2 pt-1">
                      <Link
                        to="/kontakt"
                        onClick={() => setIsOpen(false)}
                        className="w-full text-center bg-brand-accent hover:bg-brand-accent-hover text-white text-xs sm:text-[13.5px] font-bold py-2.5 px-4 rounded-xl transition-colors shadow-xs flex items-center justify-center gap-2"
                      >
                        <span>Gå til kontaktformular</span>
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                      </Link>

                      <a
                        href="tel:+4521684422"
                        className="w-full text-center bg-brand-dark hover:bg-slate-800 text-white text-xs sm:text-[13.5px] font-bold py-2.5 px-4 rounded-xl transition-colors flex items-center justify-center gap-2"
                      >
                        <svg className="w-4 h-4 text-emerald-400" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.02-.24 11.72 11.72 0 003.68.59 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.72 11.72 0 00.59 3.68 1 1 0 01-.24 1.02l-2.23 2.09z" />
                        </svg>
                        <span>Ring direkte: 21 68 44 22</span>
                      </a>
                    </div>
                  </div>
                )}

                {/* Bot Location Intent Answer */}
                {msg.sender === 'bot' && msg.type === 'location_intent' && msg.city && (
                  <div className="max-w-[96%] bg-white border border-slate-200 rounded-2xl rounded-tl-xs shadow-sm p-4 sm:p-4.5 text-slate-900 space-y-3.5 animate-in fade-in duration-200">
                    <div className="flex items-center justify-between gap-2 border-b border-slate-100 pb-2.5">
                      <span className="font-bold text-brand-dark text-sm sm:text-base flex items-center gap-1.5">
                        <span>📍</span>
                        <span>{msg.city.name}</span>
                      </span>
                      <span className="text-xs bg-red-100 text-brand-accent font-bold px-2.5 py-0.5 rounded-full whitespace-nowrap">
                        Lokal dækning
                      </span>
                    </div>

                    <p className="text-xs sm:text-[14px] text-slate-800 leading-relaxed font-normal">
                      {msg.city.response}
                    </p>

                    {msg.city.bullets && (
                      <ul className="space-y-2 bg-slate-50 p-3 rounded-xl border border-slate-200/80">
                        {msg.city.bullets.map((bullet, idx) => (
                          <li key={idx} className="flex items-start gap-2 text-xs sm:text-[13.5px] text-slate-800 leading-normal">
                            <span className="text-emerald-600 font-bold mt-0.5 text-sm">✓</span>
                            <span>{bullet}</span>
                          </li>
                        ))}
                      </ul>
                    )}

                    <div className="flex flex-col gap-2 pt-1">
                      <Link
                        to="/kontakt"
                        onClick={() => setIsOpen(false)}
                        className="w-full text-center bg-brand-accent hover:bg-brand-accent-hover text-white text-xs sm:text-[13.5px] font-bold py-2.5 px-4 rounded-xl transition-colors shadow-xs flex items-center justify-center gap-2"
                      >
                        <span>Book service / Få uforpligtende tilbud</span>
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                      </Link>

                      <div className="grid grid-cols-2 gap-2">
                        <Link
                          to="/ydelser"
                          onClick={() => setIsOpen(false)}
                          className="text-center bg-slate-100 hover:bg-slate-200 text-slate-800 text-xs sm:text-[13px] font-semibold py-2 px-3 rounded-xl transition-colors border border-slate-200"
                        >
                          Se hvad vi tilbyder
                        </Link>
                        <a
                          href="tel:+4521684422"
                          className="text-center bg-slate-100 hover:bg-slate-200 text-slate-800 text-xs sm:text-[13px] font-semibold py-2 px-3 rounded-xl transition-colors border border-slate-200 flex items-center justify-center gap-1.5"
                        >
                          <span>Ring 21 68 44 22</span>
                        </a>
                      </div>
                    </div>
                  </div>
                )}

                {/* Bot Structured Topic Answer */}
                {msg.sender === 'bot' && msg.type === 'topic_answer' && msg.topic && (
                  <div className="max-w-[96%] bg-white border border-slate-200 rounded-2xl rounded-tl-xs shadow-sm p-4 sm:p-4.5 text-slate-900 space-y-3.5">
                    {/* Topic Header Badge */}
                    <div className="flex items-center justify-between gap-2 border-b border-slate-100 pb-2.5">
                      <span className="font-bold text-brand-dark text-sm sm:text-base">
                        {msg.topic.title}
                      </span>
                      {msg.topic.badge && (
                        <span className="text-xs bg-red-100 text-brand-accent font-bold px-2.5 py-0.5 rounded-full whitespace-nowrap">
                          {msg.topic.badge}
                        </span>
                      )}
                    </div>

                    {/* Summary text */}
                    <p className="text-xs sm:text-[14px] text-slate-800 leading-relaxed font-normal">
                      {msg.topic.summary}
                    </p>

                    {/* Bullets */}
                    {msg.topic.bullets && (
                      <ul className="space-y-2 bg-slate-50 p-3 rounded-xl border border-slate-200/80">
                        {msg.topic.bullets.map((bullet, idx) => (
                          <li key={idx} className="flex items-start gap-2 text-xs sm:text-[13.5px] text-slate-800 leading-normal">
                            <span className="text-emerald-600 font-bold mt-0.5 text-sm">✓</span>
                            <span>{bullet}</span>
                          </li>
                        ))}
                      </ul>
                    )}

                    {/* Action Buttons */}
                    <div className="flex flex-col gap-2 pt-1">
                      {msg.topic.primaryAction?.url && (
                        <Link
                          to={msg.topic.primaryAction.url}
                          onClick={() => setIsOpen(false)}
                          className="w-full text-center bg-brand-accent hover:bg-brand-accent-hover text-white text-xs sm:text-[13.5px] font-bold py-2.5 px-4 rounded-xl transition-colors shadow-xs flex items-center justify-center gap-2"
                        >
                          <span>{msg.topic.primaryAction.label}</span>
                          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                          </svg>
                        </Link>
                      )}

                      {msg.topic.primaryAction?.href && (
                        <a
                          href={msg.topic.primaryAction.href}
                          target={msg.topic.primaryAction.href.startsWith('http') ? '_blank' : undefined}
                          rel={msg.topic.primaryAction.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                          className="w-full text-center bg-brand-accent hover:bg-brand-accent-hover text-white text-xs sm:text-[13.5px] font-bold py-2.5 px-4 rounded-xl transition-colors shadow-xs flex items-center justify-center gap-2"
                        >
                          <span>{msg.topic.primaryAction.label}</span>
                          {msg.topic.primaryAction.href.startsWith('http') && (
                            <i className="fa-solid fa-arrow-up-right-from-square text-xs opacity-80" />
                          )}
                        </a>
                      )}

                      {msg.topic.secondaryAction?.url && (
                        <Link
                          to={msg.topic.secondaryAction.url}
                          onClick={() => setIsOpen(false)}
                          className="w-full text-center bg-slate-100 hover:bg-slate-200 text-slate-800 text-xs sm:text-[13px] font-semibold py-2 px-3 rounded-xl transition-colors border border-slate-200"
                        >
                          {msg.topic.secondaryAction.label}
                        </Link>
                      )}

                      {msg.topic.secondaryAction?.href && (
                        <a
                          href={msg.topic.secondaryAction.href}
                          className="w-full text-center bg-slate-100 hover:bg-slate-200 text-slate-800 text-xs sm:text-[13px] font-semibold py-2 px-3 rounded-xl transition-colors border border-slate-200"
                        >
                          {msg.topic.secondaryAction.label}
                        </a>
                      )}
                    </div>
                  </div>
                )}

                {/* Bot Fallback message */}
                {msg.sender === 'bot' && msg.type === 'fallback' && (
                  <div className="max-w-[94%] bg-white border border-slate-200 rounded-2xl rounded-tl-xs shadow-sm p-4 text-slate-900 space-y-3.5">
                    <p className="text-xs sm:text-[14px] text-slate-800 leading-relaxed">
                      {msg.text}
                    </p>

                    <div className="flex flex-wrap gap-2 pt-1">
                      {KNOWLEDGE_TOPICS.map((topic) => (
                        <button
                          key={topic.id}
                          onClick={() => handleSelectQuickTopic(topic)}
                          className="bg-slate-50 hover:bg-red-50 hover:border-brand-accent text-slate-800 border border-slate-300 px-3 py-1.5 rounded-lg text-xs sm:text-[13px] font-medium transition-colors"
                        >
                          {topic.shortLabel}
                        </button>
                      ))}
                    </div>

                    <div className="pt-2 border-t border-slate-100 flex items-center gap-2">
                      <Link
                        to="/kontakt"
                        onClick={() => setIsOpen(false)}
                        className="flex-1 text-center bg-brand-dark hover:bg-slate-800 text-white text-xs sm:text-[13px] font-bold py-2.5 px-3 rounded-xl transition-colors"
                      >
                        Gå til kontaktformular
                      </Link>
                      <a
                        href="tel:+4521684422"
                        className="text-center bg-brand-accent hover:bg-brand-accent-hover text-white text-xs sm:text-[13px] font-bold py-2.5 px-3.5 rounded-xl transition-colors"
                      >
                        Ring 21 68 44 22
                      </a>
                    </div>
                  </div>
                )}
              </div>
            ))}

            {/* Bot Typing indicator */}
            {isTyping && (
              <div className="flex items-center gap-2 bg-white border border-slate-200 px-4 py-2.5 rounded-2xl rounded-tl-xs w-fit shadow-2xs">
                <span className="w-2 h-2 bg-slate-400 rounded-full animate-bounce" />
                <span className="w-2 h-2 bg-slate-400 rounded-full animate-bounce [animation-delay:0.2s]" />
                <span className="w-2 h-2 bg-slate-400 rounded-full animate-bounce [animation-delay:0.4s]" />
              </div>
            )}

            <div ref={messagesEndRef} />
          </div>

          {/* Quick suggestions chips above input */}
          <div className="bg-slate-100 border-t border-slate-200 px-3.5 py-2 flex items-center gap-2 overflow-x-auto no-scrollbar text-xs">
            <span className="text-xs text-slate-700 font-bold whitespace-nowrap">Forslag:</span>
            <button
              onClick={() => handleSelectQuickTopic(KNOWLEDGE_TOPICS[0])}
              className="bg-white hover:bg-slate-50 text-slate-800 font-medium px-2.5 py-1 rounded-md border border-slate-300 text-xs whitespace-nowrap shadow-2xs"
            >
              Portservice
            </button>
            <button
              onClick={() => handleSelectQuickTopic(KNOWLEDGE_TOPICS[1])}
              className="bg-white hover:bg-slate-50 text-slate-800 font-medium px-2.5 py-1 rounded-md border border-slate-300 text-xs whitespace-nowrap shadow-2xs"
            >
              Akut hjælp
            </button>
            <button
              onClick={() => handleSelectQuickTopic(KNOWLEDGE_TOPICS[6])}
              className="bg-white hover:bg-slate-50 text-slate-800 font-medium px-2.5 py-1 rounded-md border border-slate-300 text-xs whitespace-nowrap shadow-2xs"
            >
              Ajax alarm
            </button>
            <button
              onClick={() => handleSelectQuickTopic(KNOWLEDGE_TOPICS[7])}
              className="bg-white hover:bg-slate-50 text-slate-800 font-medium px-2.5 py-1 rounded-md border border-slate-300 text-xs whitespace-nowrap shadow-2xs"
            >
              Tilbud
            </button>
          </div>

          {/* Input Form at bottom */}
          <form onSubmit={handleSendMessage} className="p-3.5 bg-white border-t border-slate-200 flex items-center gap-2">
            <input
              ref={inputRef}
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              placeholder="Stil et spørgsmål (fx 'Hvad koster eftersyn?')..."
              className="flex-1 bg-slate-50 hover:bg-white focus:bg-white text-slate-900 placeholder:text-slate-500 text-sm px-3.5 py-2.5 rounded-xl border border-slate-300 focus:outline-none focus:ring-2 focus:ring-brand-accent/40 focus:border-brand-accent transition-all"
            />
            <button
              type="submit"
              disabled={!inputValue.trim()}
              aria-label="Send besked"
              className="bg-brand-accent hover:bg-brand-accent-hover disabled:opacity-40 disabled:hover:bg-brand-accent text-white p-2.5 rounded-xl transition-all shadow-xs flex items-center justify-center"
            >
              <svg className="w-4 h-4 transform rotate-90" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
              </svg>
            </button>
          </form>
        </div>
      )}
    </>
  );
}
